import React, { Component } from 'react'

import styles from './Icon.css'

import HomeIcon from 'icons/HomeIcon'
import NotificationsIcon from 'icons/NotificationsIcon'
import CreateIcon from 'icons/CreateIcon'
import GroupsIcon from 'icons/GroupsIcon'
import PersonIcon from 'icons/PersonIcon'

const IconWithProps = ({ icon, className, ...rest }) => {
  return React.createElement(icon, {
    ...rest,
    className: [styles.icon, className].join(' ')
  })
}

// all current icons drawn from https://github.com/gorangajic/react-icons/tree/master/md

const icons = {
  'icons/HomeIcon': HomeIcon,
  'icons/NotificationsIcon': NotificationsIcon,
  'icons/CreateIcon': CreateIcon,
  'icons/GroupsIcon': GroupsIcon,
  'icons/PersonIcon': PersonIcon
}

const Icon = ({ icon, iconName, hidden, ...rest }) => {
  if (hidden) {
    return null
  }
  if (icon) {
    return <IconWithProps icon={icon} {...rest} />
  } else {
    return <IconWithProps icon={icons[iconName]} {...rest} />
  }
}

export default Icon
